import React from 'react';
import PropType from 'prop-types';
import styled from 'styled-components';
import { colorsBar, colors } from '../../../ui/common';

const Bar = styled.div`
  display: flex;
  margin: 4px 0 0;
`;
const Dot = styled.button`
  display: block;
  position: relative;
  background: ${(props) => (props.backColor ? props.backColor : 'transparent')};
  box-sizing: border-box;
  vertical-align: middle;
  width: 24px;
  height: 24px;
  border: none;
  border-radius: 50%;
  line-height: 28px;
  margin: 4px 27px 0 2px;
  outline: none;
  cursor: pointer;
  padding: 0;
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.25);
  &:after {
    border: 1px solid ${colors.color11};
    content: '';
    position: absolute;
    width: 30px;
    height: 30px;
    top: -3px;
    left: -3px;
    border-radius: 50%;
    box-sizing: border-box;
    opacity: ${(props) => (props.active ? 1 : 0)};
  }
`;
function ColorBar({ active, onChange, colorSet }) {
  return (
    <Bar>
      {colorSet.map((el) => (
        <Dot
          key={el}
          type="button"
          aria-label={`${el} color`}
          onClick={() => onChange(el)}
          active={active === el}
          backColor={colorsBar[el]}
        />
      ))}
    </Bar>
  );
}

export default ColorBar;

ColorBar.propTypes = {
  active: PropType.string,
  colorSet: PropType.arrayOf(PropType.any),
  onChange: PropType.func,
};

ColorBar.defaultProps = {
  active: '',
  colorSet: [],
  onChange: null,
};
